document.addEventListener('DOMContentLoaded', function() {
  const STORAGE_KEY = 'user_nav_context';
  
  function getHandleFromUrl() {
    if (window.location.pathname.includes('/collections/')) {
      const parts = window.location.pathname.split('/');
      const colIndex = parts.indexOf('collections');
      if (colIndex > -1 && parts[colIndex + 1]) {
        return decodeURIComponent(parts[colIndex + 1]);
      }
    }
    return null;
  }
  
  let activeContext = null;
  const urlHandle = getHandleFromUrl();
  const storedHandle = sessionStorage.getItem(STORAGE_KEY);

  if (urlHandle) {
    activeContext = urlHandle;
    sessionStorage.setItem(STORAGE_KEY, urlHandle);
  } else if (storedHandle) {
    activeContext = storedHandle;
  }

  const potentialMenus = document.querySelectorAll('.js-potential-menu');

  if (potentialMenus.length > 1) {
    let matchIndex = -1;
    let partialIndex = -1;

    if (activeContext) {
      potentialMenus.forEach((menu, index) => {
        const handle = menu.getAttribute('data-collection-handle');
        if (!handle) return;

        if (handle === activeContext) {
          matchIndex = index; 
        } else if (activeContext.indexOf(handle) > -1 || handle.indexOf(activeContext) > -1) {
          partialIndex = index; 
        }
      });
    }

    const winningIndex = (matchIndex > -1) ? matchIndex : (partialIndex > -1 ? partialIndex : 0);

    potentialMenus.forEach((menu, index) => {
      if (index !== winningIndex) {
        menu.remove(); 
      }
    });
  }
  const mainMenus = document.querySelectorAll('.js-main-menu-item');
  
  const activeMainItems = Array.from(mainMenus).filter(item => {
     const target = item.querySelector('.js-underline-target');
     return target && target.classList.contains('underlined');
  });

  if (activeMainItems.length > 1) {
    
    let winnerItem = activeMainItems[0];
    let matchFound = false;

    if (activeContext) {
      activeMainItems.forEach((item) => {
        const handle = item.getAttribute('data-collection-handle');
        if (handle === activeContext) {
          winnerItem = item;
          matchFound = true;
        }
      });

      if (!matchFound) {
        activeMainItems.forEach((item) => {
           const handle = item.getAttribute('data-collection-handle');
           if (handle && (activeContext.indexOf(handle) > -1 || handle.indexOf(activeContext) > -1)) {
             winnerItem = item;
             matchFound = true;
           }
        });
      }
    }

    activeMainItems.forEach((item) => {
        const target = item.querySelector('.js-underline-target');
        if (target) target.classList.remove('underlined');
    });

    if (winnerItem) {
        const winnerTarget = winnerItem.querySelector('.js-underline-target');
        if (winnerTarget) winnerTarget.classList.add('underlined');
    }
  }

});